import { render, staticRenderFns } from "./media_holding_exceptions.vue?vue&type=template&id=05a0e46d&scoped=true"
import script from "./media_holding_exceptions.vue?vue&type=script&lang=js"
export * from "./media_holding_exceptions.vue?vue&type=script&lang=js"
import style0 from "./media_holding_exceptions.vue?vue&type=style&index=0&id=05a0e46d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a0e46d",
  null
  
)

export default component.exports